import React from "react";

const Goatinfo = () => {
  return (
    <>
      <div className="goat-info py-5">
        <div className="container py-lg-5">
          <div className="row m-auto py-lg-4 d-flex justify-content-end" >


            <div className="col-lg-7">
              <div className="goatinfo-content rounded-3 p-4">
                <p><span className="fw-bold">Reach Across the Nation:</span> Rumeno Farmotech makes sure that its products reach farmers and livestock owners in every corner of
                  India with more than 150 franchise locations nationwide. The company stands out for its dedication
                  to availability and accessibility.
                </p>

                <p> <span className="fw-bold">Research-Driven Approach:</span> The Rumeno Farmotech team is always conducting research and creating
                  new recipes to address the growing problems that farmers encounter. Their answers, which include
                  growth promotion and sickness prevention, are supported by research.</p>

                <p>

                  Rumeno Farmotech is a well-known veterinary feed supplement manufacturer in India that is committed to improving the well-being
                  and output of animals. They provide a large selection of feed additives for different animals, with an emphasis on quality and innovation.
                  Results-driven products are offered by Rumeno Farmotech for pigeons, poultry, fish, and cattle. Their carefully designed supplements meet particular
                  dietary requirements, guaranteeing healthy growth and warding off illness. Rumeno Farmotech is a reputable supplier of veterinary products with more
                  than 150 franchise locations nationwide, earning the trust of livestock owners. Select Rumeno Farmotech for happier animals and productive farming!
                </p>

                <p>
                  Rumeno Farmotech is aware that robust animal health is essential to agriculture. Their methodical methodology,
                  based on research, guarantees that every feed supplement is precisely designed to fulfil certain dietary needs. Rumeno Farmotech produces
                  outcomes whether it's preventing deficits, promoting growth, or boosting immunity.
                </p>

              </div>

            </div>


            {/* <div className="col-lg-2"></div>
            <div className="col-lg-5 col-md-8 m-auto py-lg-5 mb-2">
              <div className="goatinfo-content rounded-3 p-4">
                <p>
                  Research-Driven Approach: The Rumeno Farmotech team is always conducting research and creating
                  new recipes to address the growing problems that farmers encounter. Their answers, which include
                  growth promotion and sickness prevention, are supported by research.
                </p>
              </div>
            </div>


            <div className="col-lg-5 col-md-8 m-auto py-lg-5 mb-2">
              <div className="goatinfo-content rounded-3 p-4">
                <p>

                  Rumeno Farmotech is a well-known veterinary feed supplement manufacturer in India that is committed to improving the well-being
                  and output of animals. They provide a large selection of feed additives for different animals, with an emphasis on quality and innovation.
                  Results-driven products are offered by Rumeno Farmotech for pigeons, poultry, fish, and cattle. Their carefully designed supplements meet particular
                  dietary requirements, guaranteeing healthy growth and warding off illness. Rumeno Farmotech is a reputable supplier of veterinary products with more
                  than 150 franchise locations nationwide, earning the trust of livestock owners. Select Rumeno Farmotech for happier animals and productive farming!
                </p>
              </div>
            </div>
            <div className="col-lg-2"></div>
            <div className="col-lg-5 col-md-8 m-auto py-lg-5 mb-2">
              <div className="goatinfo-content rounded-3 p-4">
                <p>

                  Rumeno Farmotech is aware that robust animal health is essential to agriculture. Their methodical methodology,
                  based on research, guarantees that every feed supplement is precisely designed to fulfil certain dietary needs. Rumeno Farmotech produces
                  outcomes whether it's preventing deficits, promoting growth, or boosting immunity.
                </p>
              </div>
            </div> */}

          </div>
        </div>
      </div>
    </>
  );
};

export default Goatinfo;
